import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Assets API
export const assetAPI = {
  getAll: (params) => api.get('/assets', { params }),
  getById: (id) => api.get(`/assets/${id}`),
  getByCategory: (category) => api.get(`/assets/category/${category}`),
  upload: (formData) => api.post('/assets/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/assets/${id}`, data),
  delete: (id) => api.delete(`/assets/${id}`),
};

// Images API
export const imageAPI = {
  getAll: (params) => api.get('/images', { params }),
  getById: (id) => api.get(`/images/${id}`),
  getByCategory: (category) => api.get(`/images/category/${category}`),
  upload: (formData) => api.post('/images/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};

// Blog API
export const blogAPI = {
  getAll: (params) => api.get('/blog', { params }),
  getPublished: (params) => api.get('/blog/published', { params }),
  getBySlug: (slug) => api.get(`/blog/slug/${slug}`),
  getById: (id) => api.get(`/blog/${id}`),
  getByCategory: (category, params) => api.get(`/blog/category/${category}`, { params }),
  create: (data) => api.post('/blog', data),
  update: (id, data) => api.put(`/blog/${id}`, data),
  delete: (id) => api.delete(`/blog/${id}`),
};

// Contact API
export const contactAPI = {
  submit: (data) => api.post('/contact', data),
};

export default api;
